import { render, staticRenderFns } from "./OrderEvaluate.vue?vue&type=template&id=8b5d8f2a&scoped=true&"
import script from "./OrderEvaluate.vue?vue&type=script&lang=js&"
export * from "./OrderEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./OrderEvaluate.vue?vue&type=style&index=0&id=8b5d8f2a&lang=less&scoped=true&"
import style1 from "./OrderEvaluate.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5d8f2a",
  null
  
)

export default component.exports